export const statuses = [
  {
    "label": "Created",
    "value": "CREATED"
  },
  {
    "label": "Partially Paid",
    "value": "PARTIALLY_PAID"
  },
  {
    "label": "Fully Paid",
    "value": "FULLY_PAID"
  },
  {
    "label": "Locked",
    "value": "LOCKED"
  },
  {
    "label": "Refunded",
    "value": "REFUNDED"
  },
  {
    "label": "Ready for Shipping",
    "value": "READY_FOR_SHIPPING"
  },
  {
    "label": "Shipped",
    "value": "SHIPPED"
  },
  {
    "label": "Delivered",
    "value": "DELIVERED"
  },
  {
    "label": "Customer Feedback Awaited",
    "value": "CUSTOMER_FEEDBACK_AWAITED"
  },
  {
    "label": "Completed",
    "value": "COMPLETED"
  },
  {
    "label": "Closed",
    "value": "CLOSED"
  }
]